<template>
    <div class="page-select-wrapper" @click="clickHandler">
        <div class="cur-length">{{ currentLabel }}</div>
        <div class="pushdown-icon" :class="{ 'icon-up': isShowMenu }"></div>
        <PopupMenu
            class="page-popup"
            :menus="pages"
            :position="{ direct: 'up' }"
            :isShow="isShowMenu"
            :current="currentLength"
            @menuChange="menuChange"
            @menuHide="hideMenu"
        />
    </div>
</template>

<script>
/**
 * emit lengthChange
 */
import PopupMenu from "@/views/zhiji/bComponents/popupMenu/PopupMenu";

export default {
    name: "PageLengthSelect",
    props: ["pageRank", "curLength"],
    components: {
        PopupMenu
    },
    data() {
        return {
            currentLength: this.curLength || 10,
            isShowMenu: false
        };
    },
    computed: {
        label() {
            return this.$t("zhiji.common.tablepage");
        },
        pages() {
            let rank = this.pageRank || [10, 20, 50, 100];

            return rank.map(len => {
                return {
                    label: len + this.label,
                    value: len
                };
            });
        },
        currentLabel() {
            return this.currentLength + this.label;
        }
    },
    methods: {
        clickHandler() {
            this.isShowMenu = !this.isShowMenu;
        },
        menuChange(menu) {
            this.currentLength = menu.value;
            this.$emit("lengthChange", menu.value);
        },
        hideMenu() {
            this.isShowMenu = false;
        }
    }
};
</script>

<style lang="scss" scoped>
$pushDownIcon: url($zhijiStaticImagePath+"class-spr.png");

.page-select-wrapper {
    position: relative;
    display: inline-block;
    user-select: none;
    cursor: pointer;

    & > div {
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
    }

    .pushdown-icon {
        width: 18px;
        height: 18px;
        background: $pushDownIcon no-repeat -127px -14px;
        transform: rotate(90deg) translateX(6px);
    }

    .icon-up {
        transform: rotate(270deg) translateX(6px) translateY(-4px);
    }

    .page-popup {
        min-width: 90px;
        left: -11px !important;
    }
}
</style>
